import React, { useState } from 'react';
import styled, { withTheme } from 'styled-components/macro';
import PropTypes from 'prop-types';
import { HelperComment, Icon } from 'components/atoms';
import { themeType, iconType, historyType } from 'types';
import { withRouter } from 'react-router-dom';
import { computePathEditor } from 'services/generators';

const PageCardMain = ({
  title,
  titleIcon,
  description,
  img,
  theme,
  icon,
  history,
  to,
  isEditable,
}) => {
  const [isHover, setHover] = useState(false);

  const handleClick = () => {
    if (to) history.push(computePathEditor(to));
    return null;
  };

  const handleMouseEnter = () => {
    if (isEditable) setHover(true)
  }
  const handleMouseLeave = () => {
    if (isEditable) setHover(false)
  }

  return (
    <PageCard
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      isEditable={isEditable}
    >
      <PageCard.Preview>
        {isHover && (
          <PageCard.Hover>
            <Icon icon="edit" color="#FFF" title="editar" />
          </PageCard.Hover>
        )}

        {img ? (
          <img src={img} alt={`Imagem de partilha da página: ${title}`} />
        ) : (
          <PageCard.PreviewDefault>
            <Icon height={48} icon={icon} color={theme.colors.grey} />
          </PageCard.PreviewDefault>
        )}
      </PageCard.Preview>
      <PageCard.Description>
        <PageCard.Title lighter={!title}>
          {titleIcon && (
            <SpacingRight>
              <Icon height={13} icon={titleIcon} />
            </SpacingRight>
          )}
          {title || 'Sem título'}
        </PageCard.Title>
        <HelperComment as="p">{description}</HelperComment>
      </PageCard.Description>
    </PageCard>
  );
};

PageCardMain.propTypes = {
  title: PropTypes.string,
  titleIcon: iconType,
  description: PropTypes.string,
  img: PropTypes.string,
  theme: themeType.isRequired,
  history: historyType.isRequired,
  icon: PropTypes.string,
  to: PropTypes.string,
  isEditable: PropTypes.bool,
};

PageCardMain.defaultProps = {
  title: null,
  titleIcon: null,
  description: 'Description goes here',
  img: null,
  icon: 'description',
  to: null,
  isEditable: true,
};

const PageCard = styled.div`
  transition: all 0.2s ease-out;
  width: ${props => props.theme.components.pageCard.width};
  background-color: ${props => props.theme.colors.bgLighter};
  border: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.borderLighter};
  &:hover {
    cursor: ${props => (props.isEditable ? 'pointer' : 'not-allowed')};
  }
`;

PageCard.Preview = styled.div`
  position: relative;
  height: 120px;
  overflow: hidden;
  img {
    background-color: ${props => props.theme.colors.bgLighterS};
    min-height: 120px;
    width: 100%;
    &:-moz-loading {
      visibility: hidden;
    }
  }
`;

PageCard.PreviewDefault = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.bgLighterS};
  display: flex;
  align-items: center;
  justify-content: center;
`;

PageCard.Description = styled.div`
  position: relative;
  padding: ${props => props.theme.spacing.sm};
  border-top: 1px solid ${props => props.theme.colors.borderLighter};
`;

PageCard.Title = styled.div`
  font-size: ${props => props.theme.sizes.m};
  color: ${props => (props.lighter ? props.theme.colors.baseLighterS : props.theme.colors.greyDark)};
  font-weight: ${props => props.theme.weight.xbase};
  display: flex;
  align-items: center;
  padding-bottom: ${props => props.theme.spacing.xl2};
`;

PageCard.Hover = styled.div`
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.spacing.xs};
  position: absolute;
  left: 0;
  top: 0;
  background-color: ${props => props.theme.colors.bgHover};
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
`;

const SpacingRight = styled.div`
  padding-right: 6px;
`;

export default withRouter(withTheme(PageCardMain));
